module.exports = __webpack_public_path__ + "static/media/ELEVEN.a8550914.png";